export default __webpack_public_path__ + "static/media/logo-sukoharjo.e19c30e7.png";